import InsertLinkIcon from "@mui/icons-material/InsertLink";

const LinkCopyButton = ({ URL }) => {
  return (
    <button
      style={{
        display: "flex",
        backgroundColor: "transparent",
        border: "none",
        fontSize: "16px",
        cursor: "pointer",
      }}
      onClick={() => {
        navigator.clipboard
          .writeText(URL)
          .then(() => {
            alert("URL이 클립보드에 복사되었습니다!"); // 복사 성공 시 알림
          })
          .catch((err) => {
            console.error("클립보드 복사 실패: ", err); // 복사 실패 시 오류 출력
          });
      }}
    >
      <InsertLinkIcon />
    </button>
  );
};

export default LinkCopyButton;
